import React from 'react';

import { ConfirmationPopupProviderState } from '../states/confirmation-popup-provider-state';

const ConfirmationPopupProviderContext = React.createContext<ConfirmationPopupProviderState>({} as never);

export default ConfirmationPopupProviderContext;
